/* eslint-disable */
import Map from 'api/Map.js';
import {dynamicUrl} from 'api/constants.js';

import * as ol from 'ol';
import * as olFormat from 'ol/format';
import {defaults as olInteractionsDefaults} from 'ol/interaction';
import * as olLayer from 'ol/layer';
import * as olSource from 'ol/source';
import * as olStyle from 'ol/style';
import * as themes from 'api/Themes.js';

// The URL to the dynamic constants service.
dynamicUrl.dynamicUrl = '{FULL_ENTRY_POINT}dynamic.json?interface=api';

const lib = {
  Map,
  ol,
  olFormat,
  olInteractionsDefaults,
  olLayer,
  olSource,
  olStyle,
  themes,
};

export default lib;
